
import WDElement from '../wd-element';
import { WDFormBasic } from './wd-form-basic';
import WDUtil from '../../core/wd-util';
import { WDModelArray } from '../../core/wd-model';
import WDActivity from '../modal/wd-activity';
import WDButton from '../button/wd-button';

export class WDFormTextlist extends WDFormBasic {

  #textList;
  
  constructor(cfg)
  {
    const tl = new WDTextlist(cfg);

    cfg.type = 'textlist';
    super(tl,cfg).classList.add('wd-form-textlist');
   
    this.#textList = tl;
    this.#textList.on('change',() => { this.trigger('change'); } );

    //make sure we have at least one entry
    this.addValue('');

		//disable the button if readonly
		if (this.config?.readonly !== undefined) this.readonly = this.config.readonly;
	};

	addValue(val) 
	{ 
	  this.#textList.addValue(val); 
  };

	get valueLabel()
	{
	  return this.#textList.valueLabel;
  };

	get value() { return this.#textList.value; };
	set value(val) { this.#textList.value = val; };  
	get readonly() { return this.#textList.readonly; };
	set readonly(val) { this.#textList.readonly = val; };

	cleanupCallback()
	{
		// Clean up textlist
		if (this.#textList) {
			this.#textList = null;
		}

		super.cleanupCallback();
	}
};

customElements.define('wd-form-textlist',WDFormTextlist);

class WDTextlist extends WDElement {

  #items = [];
  #values = [];
    
  /**
    * default config
    */
	#config = { 
	  separator:', ' 
  };
    
  constructor(cfg)
  {
    super().classList.add('wd-textlist');

    if (cfg !== undefined) WDUtil.merge(this.#config,cfg);

    this.#values = new WDModelArray([]);

    this.#values.on('set', evtData => this.handleSet(evtData) );
    this.#values.on('delete', evtData => this.handleDelete(evtData) );

    //				
		if ( this.#config.value !== undefined ) this.value = this.#config.value;
	};

  get items() { return this.children; };

	removeItemAt(idx)
	{
		this.items[idx].remove();
	};

  replaceItemAt(item,idx)
  {     	
    if (idx < this.items.length)
    {   	
      const r = this.items[idx];
        	
      item.insertBefore(r);
      r.remove();
    }   	
    else	
    {   	
      this.append(item);
    }   	
  		
    return item;
  };    	


  handleSet(evtData)
  {
    /**
      create/replace a row with this index
      */
    const idx = evtData.property;
    const data = evtData.value; 

    //if the property isn't numeric, then it's an internal array property we don't want
    if (parseInt(idx) != idx) return;

    //if data is undefined, the item is being removed
    if ( data === undefined )
    {
      this.removeItemAt(idx);
    }
    //not sure this handles replacing a row
    else if ( this.items[idx] !== undefined )
    {
      this.items[idx].value = data;
    }
    else
    {
      //create the new item
			const item = new WDTextlistItem(this,idx);
			this.replaceItemAt(item,idx);
			
			if (data) item.value = data;

			item.on('item:delete',() => this.deleteValueAtIndex(idx) );
			item.on('item:add',() => this.addValueAtIndex(idx) );
			item.on('item:update',() => this.updateValueAtIndex(idx,item.value) );

			item.on('item:update item:delete',() => this.trigger('change') );
    }
  };  

  deleteValueAtIndex(idx)
  {
    if (this.#values.length == 1)
    {
      new WDActivity().showError('You cannot delete the last item');
    }
    else
    {
      this.#values.splice(idx,1);
    }
  };

  addValueAtIndex(idx)
  {
    this.#values.insert(idx+1,'');
  };
  
  updateValueAtIndex(idx,val)
  {
    this.#values[idx] = val;
  };

  addValue(val)
  {
    this.#values.push(val);
  };

  handleDelete(evtData)
  {
    const idx = evtData.property;

    //if the property isn't numeric, then it's an internal array property we don't want
    if (parseInt(idx) != idx) return;

    this.removeItemAt(idx);
  };

  get value()
  {
    return this.#values.toArray().filter(v => String(v).trim().length > 0); 
  };

  set value(val)
  {
	    if ( !Array.isArray(val) ) val = [val];
	   
      const isChanged = !Object.is(this.#values,val);
	    this.#values.replace(val);
	    this.trigger('value:set');
	   
      if (isChanged) this.trigger('change');
	    return this;
	};
    
  /**
    * generates a label based on all the selected values in the list
    */
  get valueLabel()
  {
    return this.#values.join( this.#config.separator );
  };
  
};

customElements.define('wd-textlist',WDTextlist);

class WDTextlistItem extends WDElement {

  #textbox;
  #delBtn;
  #addBtn;
  
  constructor()
  {
    super().classList.add('wd-textlist-item');

    this.#textbox = wdc('<input type="text" class="form-control form-control-sm"/>');
    this.#textbox.addEventListener('change',() => this.trigger('item:update') );
  
    this.#delBtn = new WDButton({fasIcon:'trash', size:'sm'});
    this.#delBtn.on('click',() => this.trigger('item:delete') );

    this.#addBtn = new WDButton({fasIcon:'plus', size:'sm'});
    this.#addBtn.on('click',() => this.trigger('item:add') );      

    this.append(this.#textbox);
    this.append(this.#delBtn);
    this.append(this.#addBtn);
  };
  
  get value() { return this.#textbox.value; };
  set value(val) { this.#textbox.value = this.value; };

};

customElements.define('wd-textlist-item',WDTextlistItem);
